import React, { useRef } from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { Solution } from './Solution';
import { Testimonials } from './Testimonials';
import { Reviews } from './Reviews';
import { CourseModules } from './CourseModules';
import { FAQ } from './FAQ';
import { Benefits } from './Benefits';
import { CallToAction } from './CallToAction';
import { MoreTestimonials } from './MoreTestimonials';
import { Footer } from './Footer';
import { FacebookPixel } from './FacebookPixel';
import { GoogleTag } from './GoogleTag';
import { StickyButton } from './StickyButton';
export const Advertorial = () => {
  const stickyButtonRef = useRef<HTMLHeadingElement>(null);
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800" data-id="element-6">
      <FacebookPixel data-id="element-7" />
      <GoogleTag data-id="element-8" />
      <Header data-id="element-9" />
      <Problem data-id="element-10" />
      <Solution stickyButtonRef={stickyButtonRef} data-id="element-11" />
      <Testimonials data-id="element-12" />
      <CourseModules data-id="element-13" />
      <Reviews data-id="element-14" />
      <FAQ data-id="element-15" />
      <Benefits data-id="element-16" />
      <CallToAction data-id="element-17" />
      <MoreTestimonials data-id="element-18" />
      <Footer data-id="element-19" />
      <StickyButton targetRef={stickyButtonRef} data-id="element-20" />
    </div>;
};